import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';

/**
 * Same sanitize schema + table styling hooks as the legacy chat so assistant
 * markdown renders identically in both shells.
 */
const schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    span: [...(defaultSchema.attributes?.span ?? []), 'style'],
  },
};

const components = {
  table: (props: React.ComponentProps<'table'>) => (
    <table className="custom-markdown-table" {...props} />
  ),
  th: (props: React.ComponentProps<'th'>) => (
    <th className="custom-markdown-th" {...props} />
  ),
  td: (props: React.ComponentProps<'td'>) => (
    <td className="custom-markdown-td" {...props} />
  ),
  tr: (props: React.ComponentProps<'tr'>) => (
    <tr className="custom-markdown-tr" {...props} />
  ),
  a: (props: React.ComponentProps<'a'>) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
};

interface MarkdownContentProps {
  children: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({
  children,
}) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    rehypePlugins={[
      [rehypeRaw, { passThrough: ['element'] }],
      [rehypeSanitize, schema],
    ]}
    components={components}
  >
    {children}
  </ReactMarkdown>
);

export default MarkdownContent;
